import { DefaultError, QueryCache, QueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { notificationService } from 'containers/AlertWrapper/notificationService';
import { createErrorAlertArgs } from 'utils/alertHelpers';

export const useCreateQueryClient = () => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          // Catch any react-query useQuery error globally and display the alert (this will not catch useMutation errors)
          // @ts-expect-error TS doesn't like the extra field we pass to the error
          onError: (
            error: DefaultError & { suppressErrorMessage: boolean },
          ) => {
            if (!error.suppressErrorMessage) {
              notificationService.show(
                ...createErrorAlertArgs({
                  alertMessage: error.message,
                  // @ts-expect-error TS doesn't like the extra field we pass to the error
                  error,
                }),
              );
            }
          },
        }),
      }),
  );

  return queryClient;
};
